export default __webpack_public_path__ + "cdot-logo-white.png";